import { render, staticRenderFns } from "./CodeGeneratorCategoryTableForm.vue?vue&type=template&id=e8fcabaa&scoped=true&"
import script from "./CodeGeneratorCategoryTableForm.vue?vue&type=script&lang=js&"
export * from "./CodeGeneratorCategoryTableForm.vue?vue&type=script&lang=js&"
import style0 from "./CodeGeneratorCategoryTableForm.vue?vue&type=style&index=0&id=e8fcabaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8fcabaa",
  null
  
)

export default component.exports